import { BaseCache } from './baseCache';
import { ICacheConfig } from './cache.types';

export class E2eeCache extends BaseCache {
  protected dbName = 'e2ee';

  protected groupStateObjectStoreName = 'groupState';
  protected groupStatesMemoryObjectStoreName = 'groupStatesMemory';
  protected epochStateObjectStoreName = 'epochState';
  protected groupMaxEpochStoreName = 'groupMaxEpoch';
  protected keyPackagesStoreName = 'keyPackages';
  protected webCryptoKey = 'webCryptoKey';

  constructor(config: ICacheConfig) {
    super(config);

    this.openDb();
  }

  protected initDb(): void {
    this.createStore(this.groupStateObjectStoreName);
    this.createStore(this.groupStatesMemoryObjectStoreName);
    this.createStore(this.epochStateObjectStoreName);
    this.createStore(this.groupMaxEpochStoreName);
    this.createStore(this.keyPackagesStoreName);
    this.createStore(this.webCryptoKey);
  }

  public getGroupState(id: string): Promise<Map<string, ArrayBuffer> | null> {
    return this.get(this.groupStateObjectStoreName, id);
  }

  public putGroupState(
    id: string,
    groupState: Map<string, ArrayBuffer>
  ): IDBRequest<IDBValidKey> | null {
    return this.put(this.groupStateObjectStoreName, id, groupState);
  }

  public getEpochState(id: string): Promise<Map<string, Map<bigint, ArrayBuffer>> | null> {
    return this.get(this.epochStateObjectStoreName, id);
  }

  public putEpochState(
    id: string,
    epochState: Map<string, Map<bigint, ArrayBuffer>>
  ): IDBRequest<IDBValidKey> | null {
    return this.put(this.epochStateObjectStoreName, id, epochState);
  }

  public getGroupStatesMemory(id: string): Promise<Map<string, ArrayBuffer> | null> {
    return this.get(this.groupStatesMemoryObjectStoreName, id);
  }

  public putGroupStatesMemory(
    id: string,
    epochState: Map<string, ArrayBuffer>
  ): IDBRequest<IDBValidKey> | null {
    return this.put(this.groupStatesMemoryObjectStoreName, id, epochState);
  }

  public getGroupMaxEpoch(id: string): Promise<Map<string, bigint> | null> {
    return this.get(this.groupMaxEpochStoreName, id);
  }

  public putGroupMaxEpoch(
    id: string,
    groupMaxEpoch: Map<string, bigint>
  ): IDBRequest<IDBValidKey> | null {
    return this.put(this.groupMaxEpochStoreName, id, groupMaxEpoch);
  }

  public getKeyPackages(id: string): Promise<Map<string, ArrayBuffer> | null> {
    return this.get(this.keyPackagesStoreName, id);
  }

  public putKeyPackages(
    id: string,
    keyPackages: Map<string, ArrayBuffer>
  ): IDBRequest<IDBValidKey> | null {
    return this.put(this.keyPackagesStoreName, id, keyPackages);
  }

  public getWebCryptoKeys(
    clientId: string
  ): Promise<{ iv: Uint8Array; cryptoKey: ArrayBuffer } | null> {
    return this.get(this.webCryptoKey, clientId);
  }

  public putWebCryptoKeys(
    clientId: string,
    keys: { iv: Uint8Array; cryptoKey: ArrayBuffer } | null
  ): IDBRequest<IDBValidKey> | null {
    return this.put(this.webCryptoKey, clientId, keys);
  }
}
